import React, { Component } from "react";

export default class NotFound extends Component {
  render() {
    return (
      <h2 style={{ textAlign: "center", color: "#f1f1f1" }}>
        404 Page Not Found!
      </h2>
    );
  }
}
